import { memo } from 'react'
import { Body2, Button, Tooltip, Stack } from '@collaborate-health/uikit'
import { useDispatch, useSelector } from '@tabeeb/store'
import { setSelectedTargetContentForMerging } from '@tabeeb/modules/sessionsPage/actions'
import { Paper } from '@mui/material'
import { ContentSharingModelType } from '@tabeeb/contracts/main-api/swagger-main-api'
import { getSelectedContent } from '@tabeeb/modules/sessionsPage/selectors/contentSharings'

interface SelectedTargetContentProps {
  contentSharingType: ContentSharingModelType
}

const SelectedTargetContent: React.FC<SelectedTargetContentProps> = ({ contentSharingType }) => {
  const dispatch = useDispatch()
  const selectedTargetContent = useSelector((state) => getSelectedContent(state, { contentSharingType }))

  if (!selectedTargetContent || selectedTargetContent.IsPredefined) {
    return null
  }

  return (
    <Paper variant='outlined'>
      <Stack direction='row' alignItems='center' justifyContent='space-between' p={0.5}>
        <Tooltip text={selectedTargetContent.Description}>
          <Body2 noWrap>{selectedTargetContent.Description}</Body2>
        </Tooltip>
        <Button
          variant='outlined'
          size='small'
          color='primary'
          onClick={() => dispatch(setSelectedTargetContentForMerging(null))}
        >
          Remove
        </Button>
      </Stack>
    </Paper>
  )
}

export default memo(SelectedTargetContent)

